module.exports = __webpack_public_path__ + "static/media/hero-2.2be45df0.webp";